import React from 'react'
import {useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loading from '../otros/Loading'

const AnalistaRoute = ({Component}) =>{
    const {user} = useSelector((state) => ({...state}))
    let navigate = useNavigate ()

    return user && user.token && user.rol === 'Analista' ? 
    (
    <Component/>
    ) : (
    navigate('/')
    )
}


export default AnalistaRoute